import { ITextMessage } from 'Shared/Types/chat';
import styles from './TextMessage.module.scss';

type TextMessageProps = {
  message: ITextMessage;
};

export const TextMessage: React.FC<TextMessageProps> = ({ message }) => {
  return (
    <div className={styles.textMessage}>
      <span className={styles.textMessage__content}>{message.text}</span>
    </div>
  );
};
